import { get, isArray, map, uniqBy, find, isNil } from "lodash";

// Construye la lista de opciones únicas para el Dropdown a partir de actionsList
export const buildActionOptions = (actionsList) => {
	const list = isArray(get(actionsList, "list")) ? get(actionsList, "list") : isArray(actionsList) ? actionsList : [];

	const dedup = uniqBy(list, (it) => {
		return it.id || `${it.name}::${it.type}::${it.function}`;
	});

	return map(dedup, (it, idx) => {
		return {
			key: `act-${idx}`,
			text: it.name || "Sin nombre",
			value: it.id || `${it.name}::${it.type}::${it.function}`,
			actionData: it,
		};
	});
};

export const getActionsArray = (actionsList) => {
	return isArray(get(actionsList, "list")) ? actionsList.list : isArray(actionsList) ? actionsList : [];
};

export const getActionDef = (actionsList, action) => {
	if (!action) return null;
	const arr = getActionsArray(actionsList);
	return find(arr, (a) => {
		return (a?.name || "") === (action?.name || "") && (a?.type || "external") === (action?.type || "external");
	});
};

export const ensureCurrentActionOption = (options, currentAction) => {
	if (!currentAction) return options;

	const currentActionId = currentAction.id || `${currentAction.name}::${currentAction.type}::${currentAction.function}`;
	const hasCurrentAction = options.some((o) => {
		return o.value === currentActionId;
	});

	return hasCurrentAction
		? options
		: [
				{
					key: "saved",
					text: currentAction?.name || "(guardada)",
					value: currentActionId,
					actionData: currentAction,
				},
				...options,
		  ];
};

// Devuelve clave técnica (sin espacios) y etiqueta visible
export const fieldKey = (f) => {
	return get(f, "name", "");
};

export const fieldLabel = (f) => {
	return get(f, "label", get(f, "name", ""));
};

// Migra llaves legacy con espacios/label -> claves camelCase
export const migrateValueKeys = (currentVal, fields) => {
	const result = { ...currentVal };

	map(fields, (f) => {
		const key = fieldKey(f);
		const lbl = fieldLabel(f);

		if (isNil(result[key])) {
			const legacy = get(currentVal, lbl) ?? get(currentVal, get(f, "name"));

			if (!isNil(legacy)) result[key] = legacy;
		}
	});

	return result;
};

// Convierte un objeto {name, type, function} en un string JSON para usar como value en el Dropdown
export const toValue = (obj) => {
	if (!obj || (!obj.name && !obj.type && !obj.function)) return null;
	return obj; // Retornar el objeto completo directamente
};

// Recibe un ID del Dropdown y lo transforma en objeto {name, type, function}
export const fromValue = (val, options = []) => {
	if (val == null || val === "") return null;

	const option = options.find((o) => {
		return o.value === val;
	});

	if (option && option.actionData) {
		return {
			name: option.actionData.name || "",
			type: option.actionData.type || "",
			function: option.actionData.function || "",
		};
	}
	if (typeof val === "object") {
		return { name: val.name || "", type: val.type || "", function: val.function || "" };
	}
	try {
		const p = JSON.parse(val);
		return { name: p?.name || "", type: p?.type || "", function: p?.function || "" };
	} catch {
		return null;
	}
};

// Elimina claves numéricas y, si se proveen fields, solo deja keys válidas
export const sanitizeActionValue = (value = {}, fields = []) => {
	const allowed = fields
		.map((f) => {
			return f?.name;
		})
		.filter(Boolean);
	const out = {};
	Object.entries(value).forEach(([k, v]) => {
		// descarta claves numéricas (metadatos)
		if (/^\d+$/.test(k)) return;
		// si hay fields definidos, solo acepta esas keys
		if (allowed.length && !allowed.includes(k)) return;
		out[k] = v;
	});
	return out;
};
